<template>
    <FactureCard>
      <template v-slot:title>Informations</template>
      <div class="informations--list">
        <div class="information-item">
          <span class="information--value">{{ formatDate(facture.date) }}</span>
          <span class="information--label">Date</span>
        </div>
        <div class="information-item">
          <span class="information--value">{{ facture.contact.nom || "N/A" }}</span>
          <span class="information--label">Nom</span>
        </div>
        <div class="information-item">
          <span class="information--value">{{ facture.contact.courriel || "N/A" }}</span>
          <span class="information--label">Courriel</span>
        </div>
        <div class="information-item">
          <span class="information--value">{{ facture.contact.telephone || "N/A" }}</span>
          <span class="information--label">Téléphone</span>
        </div>
        <div class="information-item">
          <span class="information--value">{{ facture.reference || "N/A" }}</span>
          <span class="information--label"># de facture</span>
        </div>
      </div>
    </FactureCard>
</template>

<script>
import FactureCard from "./FactureCard"

export default {
    props: ["facture", "formatDate"],
    components: {FactureCard}
}
</script>

<style scoped lang="scss">
.informations--list{
  display:grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 10px;
  @media screen and(max-width: 700px) {
    grid-template-columns: 1fr; 
  }
  .information-item {
    text-align: left;
    display: grid;
    grid-template-areas: 'value'
                         'label';
    @media screen and(max-width: 700px) {
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-areas: 'label value value';
    }
    .information--value{
      grid-area: value;
    }
    .information--label{
      grid-area: label;
      margin-top: -5px;
      @media screen and(max-width: 700px) {
      margin-top: 0;
     
    }
      color: #888;
      font-size: 0.9em;
    }
  }
}

</style>